import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/constants";

export default function WhatsAppFloat() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 800);
    return () => clearTimeout(t);
  }, []);

  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Hablar por WhatsApp"
      data-testid="floating-whatsapp-btn"
      className={`fixed z-50 bottom-5 right-5 md:bottom-7 md:right-7 transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      }`}
    >
      <span className="wa-float relative inline-flex items-center justify-center h-14 w-14 md:h-16 md:w-16 rounded-full bg-[var(--fb-whatsapp)] text-[#062b13] shadow-[0_18px_38px_-12px_rgba(37,211,102,0.65)] hover:scale-105 active:scale-95 transition-transform">
        <MessageCircle className="h-6 w-6 md:h-7 md:w-7" strokeWidth={2.4} />
      </span>
      <span className="sr-only">Hablar por WhatsApp</span>
    </a>
  );
}
